import { Swiper } from 'swiper/bundle';

const swipers = document.querySelectorAll('.js-testimonial-case-swiper');

swipers.forEach((swiperInstance) => {
  initializeSwiper(swiperInstance);
});

function initializeSwiper(swiperInstance) {
  const slides = swiperInstance.querySelectorAll('.swiper-slide');

  const swiper = new Swiper(swiperInstance, {
    slidesPerView: '1',
    watchOverflow: true,
    watchSlidesProgress: true,
    spaceBetween: 16,
    a11y: {
      firstSlideMessage: 'Dit is de eerste slide',
      nextSlideMessage: 'Naar de volgende slide',
      prevSlideMessage: 'Naar de vorige slide',
      lastSlideMessage: 'Dit is de laatste slide',
      paginationBulletMessage: 'Ga naar slide {{index}}',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  slides.forEach((slide, index) => {
    slide.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });
}

export { initializeSwiper };
